import React, { useState, useMemo, useEffect } from "react";
import Magnific from './magnific.jsx';

export default function ProductDrawingModal() {
    // state
    const [show, setShow] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);

    // handlers
    const handleClick = (e) => {
        setShow(true);
    };
    const handleClose = (e) => {
        setShow(false);
    };
    const handleDrawingClick = (e) => {
        e.preventDefault();
        let target = e.target;
        while (!target.href) {
            target = target.parentElement;
        }
        const index = galleryItems.findIndex(item => {
            return item.src === target.href;
        });
        setModalIndex(index);
        setShow(true);
    };

    // generate drawings gallery array
    const galleryItems = useMemo(
        () => {
            const drawings = [...document.querySelectorAll('.js-drawing')];
            return drawings.map(i => {
                return {
                    type: 'image',
                    src: i.href
                };
            });
        },
        []
    );
    // add listeners to drawings
    useEffect(
        () => {
            const drawings = [...document.querySelectorAll('.js-drawing')];
            drawings.forEach(item => {
                item.addEventListener('click', handleDrawingClick);
            });
            return () => {
                drawings.forEach(item => {
                    item.removeEventListener('click', handleDrawingClick);
                });
            };
        },
        []
    );

    // template
    const activator = <button className="panel-media-btn" type="button" onClick={handleClick}>
        <svg class="icon icon-expand"><use xlinkHref="#icon-expand"></use></svg>
        <span className="sr-only">Enlarge Drawings</span>
    </button>;

    return (
        <Magnific activator={activator} items={galleryItems} show={show} onClose={handleClose} index={modalIndex}/>    
    )
}